<template lang="pug">
  v-dialog(v-model="dialog" max-width="500")
    template(#activator="{ on, attrs }")
      slot(name="activator" :on="on" :attrs="attrs")
    v-card
      v-card-title Confirmare stergere
      v-card-text
        | Esti sigur ca vrei sa stergi definitiv institutia
        strong  {{ institution.name }}
        | ? Se vor sterge utilizatorii, documentele si toate fisierele acesteia. Actiunea este ireversibila.
        v-text-field(
          v-model="confirmation"
          :label="`Scrie CUI-ul (${institution.uic}) pentru confirmare`"
          class="mt-4"
        )
      v-card-actions
        v-spacer
        v-btn(text @click="dialog = false") Anuleaza
        v-btn(
          :disabled="confirmation !== institution.uic"
          color="red"
          class="white--text"
          @click="deleteInstitution"
        ) Sterge definitiv
</template>
<script>
export default {
  props: {
    institution: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      confirmation: ''
    };
  },
  watch: {
    dialog () {
      this.confirmation = '';
    }
  },
  methods: {
    deleteInstitution () {
      this.$store.commit('pageLoading', true);

      return this.axios.delete(`/institutions/${this.institution.id}`)
        .then(() => {
          this.$success('Institutia a fost stearsa.');
          this.dialog = false;
          this.$emit('deleted');
        })
        .catch(e => {
          this.$error(e);
        })
        .finally(() => {
          this.$store.commit('pageLoading', false);
        });
    }
  }
};
</script>
